import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custo',
  templateUrl: './custo.component.html',
  styleUrls: ['./custo.component.scss']
})
export class CustoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
